import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const { t } = useTranslation();

  const sortedComics = [...comics].sort((a, b) =>
    new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  const latestComics = sortedComics.slice(0, 6);

  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div className="animate-fade-in-up">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {t('home:latestSection.title', '最近更新')}
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              {t('home:latestSection.subtitle', '最新章节实时更新，精彩内容不容错过')}
            </p>
          </div>
          <Link
            to="/category/all"
            className="whitespace-nowrap text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group cursor-pointer"
              data-product-shop=""
              style={{ animationDelay: `${index * 0.08}s` }}
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫之家`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${
                    comic.status === '连载中'
                      ? 'bg-primary-500 text-white'
                      : comic.status === '已完结'
                      ? 'bg-accent-500 text-white'
                      : 'bg-secondary-500 text-white'
                  }`}>
                    {comic.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                更新至第{comic.chapters.length}{t('home:latestSection.chapter', '话')}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}